import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import DashboardLayout from "../../DashboardLayout";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { fetchFillErrorsByAdType } from "../../../services/axios/apiManager";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function AdFormatComparison() {
  const tableRef = useRef(null);
  const [selectedFormat, setSelectedFormat] = useState("");
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const getFillErrorsByAdType = async () => {
    const res = await fetchFillErrorsByAdType();
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
      if (selectedFormat?.length) {
        const temp = res?.data?.data?.filter(
          (f) => f.ad_type === selectedFormat
        );
        setFilteredData(temp);
      } else {
        setFilteredData(res.data.data);
      }
    }
  };

  const handleReset = () => {
    setSelectedFormat("");
    setFilteredData(tableData);
  };
  const handleSelectFormat = (str = "") => {
    setSelectedFormat(str);
    if (str?.length) {
      const temp = tableData?.filter((f) => f.ad_type === str);
      setFilteredData(temp);
    } else {
      setFilteredData(tableData);
    }
  };
  const chartData = {
    labels: filteredData.map((item) => item?.ad_type?.toUpperCase()),
    datasets: [
      {
        label: "Fill Rate",
        data: filteredData.map((item) =>
          (100 - (item?.total_error / item?.total_ads) * 100).toFixed(2)
        ),
        backgroundColor: "rgba(153, 102, 255, 0.7)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { labels: { color: "#ffffff" } },
    },
    scales: {
      x: { ticks: { color: "#ffffff" } },
      y: {
        beginAtZero: true,
        ticks: { color: "#ffffff" },
      },
    },
  };
  useEffect(() => {
    getFillErrorsByAdType();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = filteredData.map((item) => {
      return [
        item?.ad_type.toUpperCase(),
        item?.total_ads,
        item?.total_error,
        (100 - (item?.total_error / item?.total_ads) * 100).toFixed(2),
      ];
    });

    const config = {
      data: rows,
      columns: [
        { title: "Ad Format" },
        { title: "Total Ads" },
        { title: "Errors" },
        { title: "Fill Rate(%)" },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [filteredData]);
  return (
    <DashboardLayout>
      {/* Filter Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by Ad Format</h5>
          <div className="row align-items-center">
            <div className="col-md-3 mb-2">
              <Form.Select
                className="bg-dark text-light border-light"
                value={selectedFormat}
                onChange={(e) => handleSelectFormat(e.target.value)}
              >
                <option value="">All ad formats</option>
                {tableData?.map((m) => (
                  <option value={m.ad_type}>{m?.ad_type?.toUpperCase()}</option>
                ))}
              </Form.Select>
            </div>
            <div className="col-md-2 mb-2">
              <Button className="btn btn-success" onClick={handleReset}>
                Reset
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Ad Format Comparison</h5>
          <p className="card-text">
            Compare rewarded vs. interstitial vs. banner ad performance.
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {/* <Table className="table-hover table-striped align-middle table-borderless table-dark mb-0">
              <thead>
                <tr>
                  <th>Ad Format</th>
                  <th>Total Ads</th>
                  <th>Errors</th>
                  <th>Fill Rate(%)</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item?.ad_type.toUpperCase()}</td>
                    <td>{item?.total_ads}</td>
                    <td>{item?.total_error}</td>
                    <td>
                      {(
                        100 -
                        (item?.total_error / item?.total_ads) * 100
                      ).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table> */}
            {filteredData.length === 0 && (
              <p className="text-muted mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">eCPM by Ad Format</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default AdFormatComparison;
